import { render } from "./ChatSection.vue?vue&type=template&id=18ad8c6f&scoped=true"
import script from "./ChatSection.vue?vue&type=script&lang=js"
export * from "./ChatSection.vue?vue&type=script&lang=js"

import "./ChatSection.vue?vue&type=style&index=0&id=18ad8c6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ad8c6f"]])

export default __exports__